export const MENU_CLICK = 'MENU_CLICK'

export const SIDE_MENU = 'SIDE_MENU'